<template>
  <div>
    <!-- 麵包屑導航 -->
    <nav class="breadcrumb">
      <span @click="navigateToPage('home')" class="breadcrumb-item">首頁</span>
      <span class="breadcrumb-separator">></span>
      <span @click="navigateToPage('applications')" class="breadcrumb-item active">語言模型</span>
    </nav>

    <!-- 主內容區域 -->
    <div class="all-tools-page">
      <div class="sidebar">
        <h1>語言模型</h1>
        <p class="result-count">共 {{ filteredTools.length }} 筆資料</p>
        <input
          type="text"
          placeholder="搜尋工具..."
          class="search-bar"
          v-model="searchQuery"
          @input="filterTools"
        />
        <div class="filters">
          <h2>篩選條件</h2>
          <div class="filter-tags">
            <button
              class="filter-tag"
              v-for="tag in displayedUseCases"
              :key="tag"
              :class="{ active: activeTags.includes(tag) }"
              @click="toggleTag(tag)"
            >
              {{ tag }}
            </button>
          </div>
        </div>
      </div>

      <div class="tools-container">
        <div class="tools-list">
          <div class="tool-card" v-for="tool in displayedTools" :key="tool.toolId" @click="navigateToDetail(tool.toolId)">
  <div class="tool-top-border"></div>
  <div class="tool-content">
    <!-- 第一層：標題與推薦度 -->
    <div class="tool-header">
      <h3 class="tool-name">{{ tool.name }}</h3>
      <span class="tool-recommend">推薦: {{ tool.recommend }}</span>
    </div>
    <!-- 第二層：簡介 -->
    <div class="tool-description">
      {{ tool.description }}
    </div>
    <!-- 第三層：標籤 -->
    <div class="tool-tags">
      <span class="tool-tag" v-for="useCase in tool.relatedUseCases" :key="useCase">
        #{{ useCase }}
      </span>
    </div>
  </div>
</div>

        </div>

        <!-- 看更多按鈕 -->
        <div class="load-more">
          <button
            v-if="hasMore"
            class="load-more-button"
            @click="loadMore"
          >
            看更多
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "Applications",
  data() {
    return {
      tools: [], // 全部工具數據
      displayedTools: [], // 當前顯示的工具
      searchQuery: "", // 搜尋框的輸入內容
      allUseCases: [], // 全部標籤
      displayedUseCases: [], // 根據顯示的工具動態更新的標籤
      activeTags: [], // 已選中的標籤
      itemsPerPage: 6, // 每次顯示的工具數量
      currentCount: 6, // 當前顯示的工具數量
      filteredTools: [], // 篩選後的工具數據
      maxDescriptionLines: 3, // 簡介最大行數
      maxTagCount: 9, // 標籤最大行數
    };
  },
  computed: {
    hasMore() {
      return this.currentCount < this.filteredTools.length; // 判斷是否還有更多工具可顯示
    },
  },
  methods: {
    navigateToPage(page) {
      if (page === "home") {
        this.$router.push({ name: "Home" });
      } else if (page === "models") {
        this.$router.push({ name: "model" });
      }
    },
    async fetchTools() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/searchClass/3`, {
          params: { page: 1, size: 1000 },
        });
        if (response.data.rtnCode === "0000") {
          this.tools = response.data.data.tools.map((tool) => ({
            toolId: tool.toolId,
            name: tool.name,
            description: tool.description,
            recommend: tool.recommend,
            relatedUseCases: tool.relatedUseCases || [], // 新增 relatedUseCases
          }));
          this.filteredTools = [...this.tools]; // 初始化篩選數據
          this.updateDisplayedTools(); // 初始化顯示工具和標籤
        } else {
          console.error("API 錯誤:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
      }
    },
    updateDisplayedTools() {
      this.displayedTools = this.filteredTools.slice(0, this.currentCount); // 根據當前數量顯示工具
      this.updateDisplayedUseCases(); // 更新動態標籤
    },
    updateDisplayedUseCases() {
      const useCaseCount = {};
      this.displayedTools.forEach((tool) => {
        tool.relatedUseCases.forEach((useCase) => {
          if (useCase in useCaseCount) {
            useCaseCount[useCase]++;
          } else {
            useCaseCount[useCase] = 1;
          }
        });
      });

      // 更新標籤，按使用次數排序並取前 10 個
      this.displayedUseCases = Object.entries(useCaseCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10)
        .map(([useCase]) => useCase);
    },
    loadMore() {
      this.currentCount += this.itemsPerPage; // 每次增加顯示的數量
      this.updateDisplayedTools(); // 更新顯示工具和標籤
    },
    filterTools() {
      const query = this.searchQuery.toLowerCase();
      this.filteredTools = this.tools.filter(
        (tool) =>
          tool.name.toLowerCase().includes(query) ||
          tool.description.toLowerCase().includes(query)
      );
      this.currentCount = this.itemsPerPage; // 每次搜尋時重置顯示數量
      this.updateDisplayedTools(); // 更新顯示工具和標籤
    },
    toggleTag(tag) {
      if (this.activeTags.includes(tag)) {
        this.activeTags = this.activeTags.filter((activeTag) => activeTag !== tag);
      } else {
        this.activeTags.push(tag);
      }
      this.applyFilters();
    },
    applyFilters() {
      if (this.activeTags.length === 0) {
        this.filteredTools = [...this.tools];
      } else {
        this.filteredTools = this.tools.filter((tool) =>
          this.activeTags.every((tag) => tool.relatedUseCases.includes(tag))
        );
      }
      this.currentCount = this.itemsPerPage; // 每次篩選條件變化時重置顯示數量
      this.updateDisplayedTools(); // 更新顯示工具和標籤
    },
    navigateToDetail(id) {
      this.$router.push({ name: "CardDetail", params: { id } });
    },
  },
  mounted() {
    this.fetchTools();
  },
};
</script>

<style scoped>

/* 麵包屑樣式 */
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  margin-bottom: 0px; /* 與主內容分開 */
  padding: 30px 20px; /* 增加左右內邊距 */
  
 
}

.breadcrumb-item {
  cursor: pointer;
  color: #000;
  margin-right: 5px;
}

.breadcrumb-item.active {
  cursor: default;
  color: #246531;
  font-weight: bold;
}

.breadcrumb-separator {
  margin-right: 5px;
  color: #888;
}

.all-tools-page {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 左側1/4，右側3/4 */
  gap: 20px; /* 若 gap 過大，可以減小該值 */
  padding: 0px 20px; /* 減少內邊距 */
}


.sidebar {
  flex: 1;
  max-width: 100%;
  
}

.tools-container {
  margin-top: 0; /* 確保與麵包屑無多餘間距 */
}

.search-bar {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filters h2 {
  margin-bottom: 10px;
  font-weight: bold;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-tag {
  padding: 5px 10px;
  background-color: #eef1f6;
  border-radius: 16px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.filter-tag.active {
  background-color: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

.filter-tag:hover {
  background-color: #cbd5e1;
}
/* 工具列表 */
.tools-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 每排 3 列，均分 */ /* 最小寬度300px，隨剩餘寬度自適應 */
  gap: 15px; /* 縮小縫隙 */
  width: 100%; /* 保證列表區域全寬 */
  padding: 10px;
  box-sizing: border-box; /* 包括內邊距計算寬度 */
}

.tool-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%; /* 滿格寬度 */
  max-width: none; /* 限制最大寬度，避免卡片過寬 */
  height: auto; /* 高度自適應 */
  padding: 15px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  overflow: hidden;
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}



.tool-top-border {
  height: 5px;
  background-color: #045d19;
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.tool-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.tool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tool-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  max-width: 70%; /* 限制最大寬度，防止與推薦度重疊 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tool-recommend {
  font-size: 14px;
  color: #555;
}
.tool-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 從上到下排列 */
  align-items: stretch;
  flex-grow: 1;
  width: 100%;
}

.tool-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px; /* 與標籤保持一定距離 */
  min-height: 100px; /* 固定高度，確保留空間給簡介 */
  max-height: 100px; /* 最大顯示高度 */
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 最多顯示 5 行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}


.tool-tags {
  display: flex;
  flex-wrap: wrap; /* 允許換行 */
  gap: 8px;
  align-items: flex-start; /* 從上往下排列 */
  justify-content: flex-start; /* 標籤從左對齊 */
  margin-top: 20px; /* 增加與簡介區域的距離 */
  max-height: 64px; /* 限制標籤區域為兩行 */
  overflow: hidden; /* 隱藏多餘標籤 */
}




.tool-tag {
  font-size: 12px;
  background-color: #eef1f6;
  color: #095bd2;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}


.load-more {
  text-align: center; /* 居中對齊 */
  margin-top: 20px; /* 與工具列表保持距離 */
}

.load-more-button {
  padding: 10px 20px;
  background-color: #246531;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.load-more-button:hover {
  background-color: #2e8d36;
}

.load-more-button:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}


.all-tools-page {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 預設左 1/4 右 3/4 */
  gap: 20px;
}
@media (max-width: 768px) {
  .all-tools-page {
    display: flex;
    flex-direction: column; /* 垂直排列 */
    gap: 20px; /* 保持間距 */
    padding: 10px; /* 增加內邊距確保手機顯示更美觀 */
  }

  .sidebar {
    width: 100%; /* 填滿可用寬度 */
    margin-bottom: 20px; /* 與工具列表保持距離 */
  }

  .tools-container {
    width: 100%; /* 工具列表也填滿可用寬度 */
  }

  .tools-list {
    grid-template-columns: 1fr; /* 單列布局 */
    gap: 10px; /* 減小間距 */
  }

  .tool-card {
    width: 100%; /* 卡片填滿父容器 */
    max-width: 100%; /* 避免有額外限制 */
    margin: 0; /* 移除外邊距 */
  }
}


</style>
